import React from 'react';
import { Grid2 as Grid, Icon, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { getUploadData, setEnrichments } from '../../store/upload/uploadSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { ENRICHMENT_OPTIONS } from '../../utils/enrich';

const EnrichmentSelect: React.FC = () => {
	const dispatch = useAppDispatch();

	const { enrichments } = useAppSelector((state) => getUploadData(state));
	const userRoles = useAppSelector((state) => state.tab.userRoles);

	const handleChange = (_event: React.MouseEvent<HTMLElement>, newEnrichments: string[]) => {
		dispatch(setEnrichments(newEnrichments));
	};

	const allEnrichments = Object.entries(ENRICHMENT_OPTIONS);
	const availableEnrichments = allEnrichments.filter((item) => userRoles.includes(item[1].reqRole));

	return (
		<Grid container spacing={2}>
			<ToggleButtonGroup
				value={enrichments}
				onChange={handleChange}
				color="primary"
				sx={{
					my: 1,
					width: '100%',
					display: 'grid',
					gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
					gap: 1,
					'& .MuiToggleButtonGroup-grouped': {
						margin: '0 !important',
						borderRadius: (theme) => `${theme.shape.borderRadius}px !important`,
						'&:not(:first-of-type)': {
							borderLeftColor: (theme) => `${theme.palette.divider} !important`,
							borderRadius: (theme) => `${theme.shape.borderRadius}px !important`,
						},
					},
				}}
			>
				{allEnrichments.map(([id, item]) => (
					<ToggleButton
						key={id}
						data-testid={`${id}-enrichment-toggle`}
						value={id}
						color="primary"
						disabled={!availableEnrichments.map((enrichment) => enrichment[0]).includes(id)}
					>
						<Stack direction="row" gap={2} alignItems="center" width="100%">
							<Icon fontSize="large" component={item.icon} sx={{ ml: 1 }} />
							<Stack>
								<Typography textAlign={'left'} color="inherit">
									{item.label}
								</Typography>
								<Typography textAlign={'left'} color="inherit" textTransform={'none'}>
									{item.desc}
								</Typography>
							</Stack>
						</Stack>
					</ToggleButton>
				))}
			</ToggleButtonGroup>
		</Grid>
	);
};

export default EnrichmentSelect;
